import { render } from "./yearVoteView.vue?vue&type=template&id=30196cbc&scoped=true"
import script from "./yearVoteView.vue?vue&type=script&lang=ts"
export * from "./yearVoteView.vue?vue&type=script&lang=ts"

import "./yearVoteView.vue?vue&type=style&index=0&id=30196cbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30196cbc"

export default script